import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import type { VenueLayout } from "../../types/venues.types";

interface VenueLayoutsGridProps {
  layouts: VenueLayout[];
  layoutImages: Record<string, string>;
}

export const VenueLayoutsGrid: React.FC<VenueLayoutsGridProps> = ({
  layouts,
  layoutImages,
}) => {
  return (
    <Box sx={{ flexGrow: 1, mt: 2 }}>
      <Grid container spacing={2}>
        {layouts.map((layout, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            {layout.layout_type && layoutImages[layout.layout_type] && (
              <Paper
                sx={{
                  borderRadius: 2,
                  padding: 1,
                  textAlign: "center",
                  boxShadow: 0,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ fontWeight: "bold", mb: 1 }}
                >
                  {layout.layout_type.charAt(0).toUpperCase() +
                    layout.layout_type.slice(1)}{" "}
                  Layout
                </Typography>
                <img
                  src={layoutImages[layout.layout_type] || "/placeholder.svg"}
                  alt={`${layout.layout_type} layout`}
                  style={{
                    width: "100%",
                    maxHeight: 150,
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
              </Paper>
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default VenueLayoutsGrid;
